<template>
  <div class="flex flex-col items-center justify-center min-h-screen px-4">
    <div class="w-full max-w-lg p-6 bg-white rounded-lg shadow-md">
      <h3 class="mb-4 text-lg font-semibold">Select Donation Type</h3>
      <div class="grid grid-cols-2 gap-4">
        <button
          v-for="option in donationTypes"
          :key="option.value"
          type="button"
          class="flex flex-col items-center px-4 py-6 text-center transition border rounded-xl hover:border-orange-300 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
          :class="selected === option.value ? 'border-orange-400 ring-1 ring-orange-300' : 'border-gray-200'"
          @click="select(option.value)"
        >
          <span class="flex items-center justify-center w-12 h-12 mb-3 bg-gray-100 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 12h4l2-6 4 12 2-6h6" />
            </svg>
          </span>
          <span class="text-base font-semibold text-gray-900">{{ option.label }}</span>
          <span class="mt-1 text-sm text-gray-400">{{ option.description }}</span>
        </button>
      </div>
    </div>

    <div class="flex justify-between w-full max-w-lg mt-8">
      <button type="button" class="px-4 py-2 text-orange-500 border border-orange-500 rounded" @click="moveToPrevious">Back</button>
      <CustomButton type="button" label="Next" class="px-4 py-2" bg-class="bg-custom-yellow" :disabled="!selected" @click="proceed" />
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "DonationType",
  components: {
    CustomButton,
  },
  data() {
    return {
      selected: null,
      donationTypes: [
        {
          value: "normal",
          label: "Normal",
          description: "Whole blood donation",
        },
        {
          value: "apheresis",
          label: "Apheresis",
          description: "Platelets/Plasma",
        },
      ],
    };
  },
  methods: {
    select(value) {
      this.selected = value;
    },
    proceed() {
      if (this.selected) {
        this.$emit("select", this.selected);
        this.$emit("move-to-next-step");
      }
    },
    moveToPrevious() {
      this.$emit("move-to-previous-step");
    },
  },
};
</script>